import React from "react";
import Header from "./components/header/Header";
import MainPage from "./pages/main-page/MainPage";

function App() {
  return (
    <div className="page">
      <Header />
      <MainPage />
    </div>
  );
}

export default App;
